import { useChatContext } from './ChatContext';

const useUnlockExpProcessing = () => {
    const { isUnlockExpProcessing, setIsUnlockExpProcessing, openAuthPopup } = useChatContext();
    return { isUnlockExpProcessing, setIsUnlockExpProcessing, openAuthPopup };
};

export default useUnlockExpProcessing;
